module.exports = __webpack_public_path__ + "static/media/map-bg.a9adfd33.svg";